import { StyleSheet, css } from 'aphrodite';
import type { FC } from 'react';
import { Button } from '../../../web/components-v2/Button';
import {
	Dialog,
	DialogBody,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogPopup,
	DialogTitle,
} from '../../../web/components-v2/Dialog';
import { IconSparkles } from '../ui/icons';
import { MetricsStrip } from './MetricsStrip';
import type { DialMilestone } from './useDialMilestoneTrigger';

export type PacingMilestoneDialogProps = {
	open: boolean;
	onOpenChange: (open: boolean) => void;
	milestone: DialMilestone | null;
};

export const PacingMilestoneDialog: FC<PacingMilestoneDialogProps> = ({ open, onOpenChange, milestone }) => {
	if (!milestone) return null;

	return (
		<Dialog open={open} onOpenChange={onOpenChange}>
			<DialogPopup styles={[styles.popup]}>
				<DialogHeader>
					<div className={css(styles.iconRow)}>
						<span className={css(styles.iconBadge)}>
							<IconSparkles size={18} sw={2} />
						</span>
					</div>
					<DialogTitle>{milestone.dialsToday} dials — keep going.</DialogTitle>
					<DialogDescription>Here's where you are today.</DialogDescription>
				</DialogHeader>
				<DialogBody>
					<MetricsStrip variant='modal' input={milestone} />
				</DialogBody>
				<DialogFooter>
					<Button variant='primary' size='lg' onClick={() => onOpenChange(false)}>
						Keep going
					</Button>
				</DialogFooter>
			</DialogPopup>
		</Dialog>
	);
};

const styles = StyleSheet.create({
	popup: {
		maxWidth: 460,
	},
	iconRow: {
		display: 'flex',
		justifyContent: 'center',
		marginBottom: 8,
	},
	iconBadge: {
		width: 44,
		height: 44,
		borderRadius: 12,
		background: 'var(--accent-soft)',
		color: 'var(--accent-ink)',
		display: 'inline-flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
});
